import { render, staticRenderFns } from "./wdtWaitUpMoveDetail.vue?vue&type=template&id=96b9bd7c&scoped=true"
import script from "./wdtWaitUpMoveDetail.vue?vue&type=script&lang=js"
export * from "./wdtWaitUpMoveDetail.vue?vue&type=script&lang=js"
import style0 from "./wdtWaitUpMoveDetail.vue?vue&type=style&index=0&id=96b9bd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b9bd7c",
  null
  
)

export default component.exports